<script setup lang="ts">
import type { Institution } from '@/models/current-student-advanced-standing-form/api'
import { displayInstitution } from '@/models/current-student-advanced-standing-form/display'
import LegacyAutocompleteDropdown from '@/components/current-student-advanced-standing-form/shared/LegacyAutocompleteDropdown.vue'

defineProps<{
  institutionSearchText: string
  institutionSuggestions: Institution[]
  institutionActiveIndex: number
}>()

const emit = defineEmits<{
  'update:institutionSearchText': [value: string]
  useCustomInstitution: []
  institutionSearchInput: []
  institutionSearchKeydown: [event: KeyboardEvent]
  institutionSearchBlur: []
  activateInstitution: [index: number]
  selectInstitution: [institution: Institution]
}>()

function onInstitutionInput(event: Event): void {
  emit('update:institutionSearchText', (event.target as HTMLInputElement).value)
  emit('institutionSearchInput')
}

function institutionSuggestionKey(item: unknown): string | number {
  const institution = item as Institution
  return institution.id ?? institution.name
}

function institutionSuggestionLabel(item: unknown): string {
  const institution = item as Institution
  return institution.value ?? displayInstitution(institution)
}
</script>

<template>
          <fieldset>
            <legend>Institution Details</legend>

            <div class="form-field requiredinput form-autocomplete-field">
              <label for="institutionSearchBox">
                What Institution did you study at?
                <a href="#" id="customCourseInstNameBtn" @click.prevent="emit('useCustomInstitution')">Cannot find your institution?</a>
              </label>
              <input
                id="institutionSearchBox"
                :value="institutionSearchText"
                placeholder="Enter an institution here"
                class="form-control"
                autocomplete="off"
                @input="onInstitutionInput"
                @keydown="emit('institutionSearchKeydown', $event)"
                @blur="emit('institutionSearchBlur')"
              >
              <LegacyAutocompleteDropdown
                :items="institutionSuggestions"
                :visible="institutionSuggestions.length > 0"
                :active-index="institutionActiveIndex"
                :item-key="institutionSuggestionKey"
                :item-label="institutionSuggestionLabel"
                @activate="emit('activateInstitution', $event)"
                @select="emit('selectInstitution', $event as Institution)"
              />
            </div>

            <div class="form-field" style="display: none;">
              <label for="externalInstitutionNameInput">Institution name?</label>
              <input id="externalInstitutionNameInput" class="form-control" data-admissions-name="external_institution_name" data-admissions-group="CourseInfo">
            </div>
          </fieldset>
</template>
